import { Controller, useFormContext } from 'react-hook-form';
import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as BlockIcon } from 'assets/icons/block.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';
import { BlockCardBody } from 'api/cards/cards.types';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { BlockMultiCardsProps } from './BlockMultiCards.types';

export const BlockMultiCards = ({
  checkedCards,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: BlockMultiCardsProps) => {
  const { formatMessage } = useLocale();

  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useFormContext<BlockCardBody>();

  const { perms } = usePermissions();
  const isDisabled = !perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={!isDisabled}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={
            <BlockIcon style={{ filter: isDisabled ? 'grayscale(1)' : 'none', opacity: isDisabled ? 0.5 : 1 }} />
          }
          onClick={onModalOpen}
          disabled={isDisabled}
        >
          {formatMessage({ id: AppMessages['cards.multiAction.block.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['cards.multiAction.block.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isLoading || !isValid}
        submitButtonText={formatMessage({ id: AppMessages['cards.multiAction.block.actionButton'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['cards.multiAction.block.subtitle'] })} {checkedCards.length}
          </ActionModal.Subtitle>

          <Controller
            name="powodBlokady"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['cards.multiAction.block.reason.label'] })}
                placeholder={formatMessage({ id: AppMessages['cards.multiAction.block.reason.placeholder'] })}
                required
                errorMessage={error?.message}
              />
            )}
          />
        </>
      </ActionModal>
    </>
  );
};
